var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{ref:"gridPage",attrs:{"form-default":_vm.shipping_address_default(),"filters-default":{
            type: '',
            sort: 'name',
        },"filter-items":[
            {
                vModel: 'type',
                title: 'タイプ',
                options: [
                    { text: '全て', value: '' },
                    { text: '発送人', value: 'from' },
                    { text: '受取人', value: 'to' },
                    { text: '輸入者', value: 'importer' } ],
            },
            {
                vModel: 'sort',
                title: '順番',
                options: [
                    {
                        text: '▲ 名前',
                        value: 'name',
                    },
                    { text: '▼ 名前', value: '-name' } ],
            } ],"filters-q-placeholder":"名前、TEL、メールアドレス","form-modal-id":"shipping_address","search-action":"shipping_address/index","item-id":"id"},on:{"after-save":_vm.onAfterSave},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('ShippingAddress',{attrs:{"model":form,"init":init}})]}},{key:"column",fn:function(ref){
        var item = ref.item;
return [_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[_c('p',{staticClass:"mb-1"},[_c('b-badge',{attrs:{"variant":_vm.$store.getters['shipping_address/type2variant'](item.type)}},[_vm._v("\n                        "+_vm._s(_vm.trans.labels[
                        'shipping_addresses.type.' + item.type
                        ])+"\n                    ")]),_vm._v(" "),(item.is_default)?_c('span',[_vm._v("\n                        ※初期値\n                    ")]):_vm._e()],1),_vm._v(" "),(item.name)?_c('p',[_vm._v("\n                    "+_vm._s(item.name)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[(item.representative)?_c('div',[_vm._v("\n                    "+_vm._s(item.representative)+"\n                ")]):_vm._e(),_vm._v(" "),(item.tel)?_c('div',[_c('i',{staticClass:"far fa-fw fa-envelope"}),_vm._v(" "),_c('b-link',{attrs:{"href":'tel:' + item.tel}},[_vm._v(_vm._s(item.tel))])],1):_vm._e(),_vm._v(" "),(item.email)?_c('div',[_c('i',{staticClass:"far fa-fw fa-envelope"}),_vm._v(" "),_c('b-link',{attrs:{"href":'mailto:' + item.email}},[_vm._v(_vm._s(item.email))])],1):_vm._e()])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }